// extracted by mini-css-extract-plugin
export default {"linkContainer":"link_linkContainer__6H79y"};